import type { FC, ReactNode } from 'react'
import type { ContentCard } from '@/lib/content/types'

import { ActionLink, SectionHeader } from '@/components/site/primitives'
import { ArticleCard } from '@/components/site/article-card'

interface ArticleRelatedProps {
    items: Array<ContentCard>
    eyebrow: string
    title: string
    text?: string
    backHref: string
    backLabel: string
}

/** Up to three related cards and a link back to the section. */
export const ArticleRelated: FC<ArticleRelatedProps> = ({ items, eyebrow, title, text, backHref, backLabel }): ReactNode => {
    if (items.length === 0) return null

    return (
        <section className='border-t border-border bg-mist/60 py-20 sm:py-24'>
            <div className='container-page'>
                <div className='flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between'>
                    <SectionHeader eyebrow={eyebrow} title={title} text={text} />

                    <ActionLink href={backHref} variant='outline' arrow className='self-start sm:self-auto'>
                        {backLabel}
                    </ActionLink>
                </div>

                <div className='mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3'>
                    {items.slice(0, 3).map(item => (
                        <ArticleCard key={`${item.type}-${item.id}`} item={item} />
                    ))}
                </div>
            </div>
        </section>
    )
}
